import { useRouter } from 'next/router';
import { Stack } from '@pairy/pds-react';

import PdfInfoWithButtons from '@/components/User/_components/pdf/PdfInfoWithButtons';
import useFile from '@/hooks/queries/file/useFile';
import BulkLinkCopySection from '@/components/User/_components/pdf/BulkLinkCopySection';
import BulkPdfInfoWithButtons from '@/components/User/_components/pdf/BulkPdfInfoWithButtons';

import OneToOne from './OneToOne';

const TrackingClients = () => {
  const router = useRouter();

  const fileId = Number(router.query.fileId);

  const { data: fileData } = useFile(
    {
      fileId,
    },
    {
      enabled: Boolean(fileId),
      select: (data) => data.data.data.file,
    },
  );

  return (
    <>
      <Stack direction="column" gap={8}>
        {fileData?.isBulk ? <BulkPdfInfoWithButtons /> : <PdfInfoWithButtons />}

        {fileData?.isBulk ? (
          <BulkLinkCopySection
            fileName={fileData.name}
            fileThumbnail={fileData.thumnail}
          />
        ) : (
          <OneToOne />
        )}
      </Stack>
    </>
  );
};

export default TrackingClients;
